<template>
  <scroll-area class="work-area workarea">
    <template v-for="item in objectModel.propertiesAndPropertySections">
      <template v-if="item instanceof ObjectModelProperty">
        <base-object-model-property
          :object-model-property="item"
          :key="item.client_id"
        />
      </template>
      <template v-else>
        <property-section-builder-element
          :property-section="item"
          :key="item.client_id"
        />
      </template>
    </template>

    <div v-if="isEmpty" class="drop-in-zone empty">
      <p><b>Drag and Drop</b> property types here</p>
    </div>
  </scroll-area>
</template>

<script lang="ts">
  import Vue from "vue";
  import * as _ from 'lodash'
  import workareaDragMixin from "../../../common/mixins/drag/workareaDragMixin"
  import storeMapper from "../../../common/mixins/storeMappers/storeMapper";
  import ObjectModelProperty from "../../../common/models/objectModelProperties/objectModelProperty";
  import BaseObjectModelProperty from "./base-object-model-property.vue";
  import ObjectModel from "../../../common/models/objectModel";
  import {BuilderArea} from "../enums/builder-area";
  import PropertySection from "~/models/objectModels/propertySection";
  import PropertySectionBuilderElement from './property-section-builder-element.vue'

  const objectModelStoreMixin = storeMapper('objectModelStore', {state: ['objectModel']});

  export default Vue.extend({
    components: {
      BaseObjectModelProperty,
      PropertySectionBuilderElement
    },
    mixins: [
      workareaDragMixin,
      objectModelStoreMixin
    ],
    data: function () {
      return {
        draggableClasses: ['object-model-property', 'property-section'],
        droppableClasses: ['object-model-property', 'property-section', 'model-builder'],
        dragArea: BuilderArea.properties,
        ObjectModelProperty,
      };
    },
    computed: {
      objectModelProperties(): ObjectModelProperty[] {
        return this.objectModel.objectModelPropertiesArray.filter((p) => !p.property_section_client_id)
      },
      propertySections(): PropertySection[] {
        return this.objectModel.propertySectionsArray
      },
      targetRoot(): ObjectModel {
        return this.objectModel;
      },
      isEmpty() {
        return (this.objectModelProperties.length === 0) && (this.propertySections.length === 0)
      }
    },
    methods: {
    },
  });
</script>